/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SpokenLanguage
 */
export interface SpokenLanguage {
    /**
     * 
     * @type {string}
     * @memberof SpokenLanguage
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof SpokenLanguage
     */
    level: SpokenLanguageLevelEnum;
}


/**
 * @export
 */
export const SpokenLanguageLevelEnum = {
    Basic: 'BASIC',
    Conversational: 'CONVERSATIONAL',
    Fluent: 'FLUENT',
    Native: 'NATIVE'
} as const;
export type SpokenLanguageLevelEnum = typeof SpokenLanguageLevelEnum[keyof typeof SpokenLanguageLevelEnum];


/**
 * Check if a given object implements the SpokenLanguage interface.
 */
export function instanceOfSpokenLanguage(value: object): value is SpokenLanguage {
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('level' in value) || value['level'] === undefined) return false;
    return true;
}

export function SpokenLanguageFromJSON(json: any): SpokenLanguage {
    return SpokenLanguageFromJSONTyped(json, false);
}

export function SpokenLanguageFromJSONTyped(json: any, ignoreDiscriminator: boolean): SpokenLanguage {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'],
        'level': json['level'],
    };
}

export function SpokenLanguageToJSON(value?: SpokenLanguage | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'code': value['code'],
        'level': value['level'],
    };
}

